// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__XTqNP","focused":"Textarea_focused__UFiRd"};